import { IconButton, Snackbar } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface ToastContextProps {
  show: (message: string) => void;
}

const toastContextDefault: ToastContextProps = {
  show: () => {},
};

export const ToastStateContext =
  React.createContext<ToastContextProps>(toastContextDefault);

const ToastContextFC: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");

  function show(message: string) {
    setMessage(message);
    setVisible(true);
  }

  function handleClose() {
    setVisible(false);
  }

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <ToastStateContext.Provider value={{ show }}>
      {children}
      <Snackbar
        open={visible}
        autoHideDuration={3000}
        message={message}
        onClose={() => setVisible(false)}
        // anchorOrigin={{ vertical: "top", horizontal: "center" }} // base position
        sx={{
          "&.MuiSnackbar-root": {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            zIndex: 9999,
          },
          ".MuiPaper-root": {
            height: 75,
          },
          ".MuiSnackbarContent-message": {
            fontSize: 16,
          },
        }}
        action={action}
      ></Snackbar>
    </ToastStateContext.Provider>
  );
};

export const useToast = () => React.useContext(ToastStateContext);

export default ToastContextFC;
